module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsors-view"
  }, [(_vm.sponsorAdded) ? _c('div', {
    staticClass: "sponsor-added-notification"
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t("addSponsorView.sponsorAdded")) + "\r\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button button-green",
    on: {
      "click": function($event) {
        _vm.inviteSponsor()
      }
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("sponsorsView.inviteSponsor")) + "\r\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button button-green",
    on: {
      "click": function($event) {
        _vm.addSponsor()
      }
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("sponsorsView.addSponsor")) + "\r\n        ")])]), _vm._v(" "), (_vm.participatingSponsors.length > 0) ? _c('div', [_c('h2', [_vm._v("\r\n            " + _vm._s(_vm.$t("sponsorsView.participatingSponsors")) + "\r\n        ")]), _vm._v(" "), _vm._l((_vm.participatingSponsors), function(s) {
    return _c('div', {
      key: s.sponsorId
    }, [_c('kk-sponsor-list-item', {
      attrs: {
        "sponsor": s
      },
      on: {
        "reminder": _vm.sendReminder,
        "reinvite": _vm.reInvite,
        "bill": _vm.sendBill
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.paidSponsors), function(s) {
    return _c('div', {
      key: s.sponsorId
    }, [_c('kk-sponsor-list-item', {
      attrs: {
        "sponsor": s
      },
      on: {
        "reminder": _vm.sendReminder,
        "reinvite": _vm.reInvite
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("sponsorsView.sentInvitations")))]), _vm._v(" "), (_vm.invitedSponsors.length == 0) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("sponsorsView.noInvitations")))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.invitedSponsors), function(s) {
    return _c('div', {
      key: s.sponsorId
    }, [_c('kk-sponsor-list-item', {
      attrs: {
        "sponsor": s
      },
      on: {
        "reminder": _vm.sendReminder,
        "reInvite": _vm.reInvite
      }
    })], 1)
  }), _vm._v(" "), (_vm.refusedSponsors.length > 0) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("sponsorsView.notParticipating")))]), _vm._v(" "), _vm._l((_vm.refusedSponsors), function(s) {
    return _c('div', {
      key: s.sponsorId
    }, [_c('kk-sponsor-list-item', {
      attrs: {
        "sponsor": s
      },
      on: {
        "reminder": _vm.sendReminder,
        "reInvite": _vm.reInvite
      }
    })], 1)
  })], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca2b3e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/SponsorsView.vue
// module id = 115
// module chunks = 0